module.exports = __webpack_public_path__ + "media/images/front/varieties/CLEMENVILLA-1ff9009fa9d1c9cf2c0f8fb7fde7067a.jpg";